import * as c from '@chakra-ui/react'
import React, { useContext } from 'react'

import {
  PropertyCardContext,
  PropertyCardProvider,
} from '../property-card.context'
import Toast from './toast'

const PropertyMinimalCard = () => {
  const { property, clickRedirect } = useContext(PropertyCardContext)

  return (
    <div>
      <Toast />
      <c.Flex
        direction="column"
        align="center"
        gap={2}
        minH="138.5px"
        maxH="138.5px"
        minW="140px"
        maxW="140px"
        pos="relative"
        onClick={clickRedirect}
      >
        <c.Image
          src={`${process.env.REACT_APP_CDN_IMAGE}/${property?.mainPhoto}`}
          alt={property?.address?.neighborhood?.name}
          w="100%"
          h="100%"
          objectFit="cover"
          objectPosition="center"
          maxH={130}
          borderRadius="8px"
        />

        <c.Text color="black.500" fontSize={12} fontWeight={500} noOfLines={2}>
          {property?.aliasName}
        </c.Text>
      </c.Flex>
    </div>
  )
}

const Card = React.forwardRef(({ property = {}, ...props }, ref) => (
  <div ref={ref} onClick={props.onClick}>
    <PropertyCardProvider {...props} property={property}>
      <PropertyMinimalCard {...props} />
    </PropertyCardProvider>
  </div>
))

export default Card
